module.exports = function() {
  return new Worker(__webpack_public_path__ + "577ad36bc330bc4284c2.worker.js");
};